import * as React from 'react';

export default () => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13"
          height="18"
          viewBox="0 0 13 18"
        >
          <path d="M0 0v3.375h2.167V2.25h3.25v13.5H3.25V18h6.5v-2.25H7.583V2.25h3.25v1.125H13V0H0z"></path>
        </svg>
    );
}